import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {BuyOnCreditHistory} from "@/models";

export class BuyOnCreditService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {        
    }

    public GetAllHistories(query: any) {
        return this.baseApiFactory.getData<BuyOnCreditHistory[]>('/api/BuyOnCredit', query);
    }

    public InsertBalance(values: any) {
        return this.baseApiFactory.post<any>('/api/BuyOnCredit', values);
    }

    public GetCurrentBalance(customerId: number) {
        return this.baseApiFactory.getData<any>(`/v2/api/buy-on-credit/balance/${customerId}`);
    }
}

lazyRegister.service('BuyOnCreditService', BuyOnCreditService);
